import { render, staticRenderFns } from "./UserOfNetsisKasaCollarStatusUpdate.vue?vue&type=template&id=64ebf967&"
import script from "./UserOfNetsisKasaCollarStatusUpdate.vue?vue&type=script&lang=js&"
export * from "./UserOfNetsisKasaCollarStatusUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports